import React, {useEffect,  useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoService from "../../services/EstacionamientoService"
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import Botonera from "./Botonera";
import IndicadorCredito from "./IndicadorCredito";
import EPagosSites from "../EPagosSites";
import BotoneraWithFooter from "./BotoneraWithFooter";
import EstacionamientoSmallHeader from "./EstacionamientoSmallHeader";


const EstacionamientoEPagos = () => {
  const navigate=useNavigate();
    return (
      <section>
      <main>
 <div class="container text-center estacionamientoContent" >
 <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/botoneracredito")}}/>
 <EstacionamientoSmallHeader texto="" retorno="/botoneracredito"/>
 <div class="row">
        <div class="col miniTitle">Confirmaci&oacute;n de carga</div></div>
    <div class="row"><div class="col">&nbsp;</div></div>    
 <div class="row">
 <div class="col miniText">Est&aacute;s por cargar cr&eacute;dito al celular {localStorage.getItem("estacionamiento_celular")}, </div>
 </div>
<div class="row">
<div class="col miniText2">por un monto de ${localStorage.getItem("estacionamiento_carga_monto")}.00</div>
</div>
<div class="row"><div class="col">&nbsp;</div></div>
       <div class="row">
        <div class="col">
        <form id="myForm" name="pago" action="https://post.epagos.com.ar/" method="post">
  <input type="HIDDEN" name="version" value="1" />
  <input type="HIDDEN" name="operacion" value="op_pago" />
  <input type="HIDDEN" name="id_organismo" value="66" />
  <input type="HIDDEN" name="convenio" value="40066" />
  <input type="HIDDEN" name="token" value={  localStorage.getItem("estacionamiento_carga_hash")} />
  <input type="HIDDEN" name="numero_operacion" value={  
                localStorage.getItem("estacionamiento_carga_operacion")} />
  <input type="HIDDEN" name="id_moneda_operacion" value="1" />
  <input type="HIDDEN" name="monto_operacion" value={  localStorage.getItem("estacionamiento_carga_monto")} />
  <input type="HIDDEN" name="detalle_operacion_visible" value="1" />
  <input type="HIDDEN" name="ok_url" value="https://ww.fire-bots.com/admins/api/redirect.php?redirect=1"/>
  <input type="HIDDEN" name="error_url" value="https://ww.fire-bots.com/admins/api/redirect.php?redirect=0" />
  <input type="HIDDEN" name="identificador_2" value="SEM" />
  <input type="HIDDEN" name="tp_excluidos" value="1,4,5,7,8,9" />
  <input type="submit" class="buttonClip" text="Confirmar carga" value="Confirmar carga"></input>
</form>
</div>
</div>
</div>
</main>
</section>

    );
}

export default EstacionamientoEPagos;